interface DragZoneContext {
  id: string
  isHover: Ref<boolean>
  setChildrenDragged: (index: number) => void
  removeChildrenDragged: () => void
  disabled: ComputedRef<boolean>
}

interface DragItemContext {
  index: number
  data: any
  isDragged: Ref<boolean>
  disabled: ComputedRef<boolean>
  toggleDraggable: (value: boolean) => void
}

export const DropZoneInjectKey = Symbol('DragZoneContext') as InjectionKey<DragZoneContext | null>
export const DragItemContextInjectKey = Symbol('DragItemContext') as InjectionKey<DragItemContext | null>

export function useDragZoneContext() {
  return inject(DropZoneInjectKey, null)
}

export function useDragItemContext() {
  return inject(DragItemContextInjectKey, null)
}

export enum CLASS_MARKER {
  HOVER = 'hover',
  DRAGGED = 'dragged',
  DRAGGABLE = 'dragable',
}
